import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AlertTriangle, CircleAlert, Info, LucideAngularModule, LucideIconData } from 'lucide-angular';
import { ThemeService } from './core/services/theme.service';
import { LanguageService } from './core/services/language.service';
import { ConfirmService } from './core/services/confirm.service';
import { DownloadTrackerComponent } from './shared/download-tracker';
import { UploadTrackerComponent } from './shared/upload-tracker';
import { GlobalDropZoneService, GlobalDropZoneOverlayComponent, UploadConfirmModalComponent } from './shared/global-drop-zone';
import { DemoOverlayComponent } from './core/demo/demo-overlay/demo-overlay.component';
import { DemoModeService } from './core/demo/demo-mode.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ButtonModule,
    ToastModule,
    ConfirmDialogModule,
    LucideAngularModule,
    DownloadTrackerComponent,
    UploadTrackerComponent,
    GlobalDropZoneOverlayComponent,
    UploadConfirmModalComponent,
    DemoOverlayComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private readonly _theme = inject(ThemeService);
  // Eagerly instantiate so <html lang> is set from resolveAppLocale() at bootstrap
  // (WCAG 3.1.1) — otherwise the static lang="tr" in index.html sticks on the login page.
  private readonly _language = inject(LanguageService);
  protected readonly confirm = inject(ConfirmService);
  protected readonly demoMode = inject(DemoModeService);
  private readonly dropZone = inject(GlobalDropZoneService);

  protected readonly alertIcons: Record<string, LucideIconData> = {
    error: CircleAlert,
    warning: AlertTriangle,
    info: Info,
  };

  constructor() {
    // this.dropZone.initialize();
  }
}
